/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import PreguntasFrecuentesForm from './PreguntasFrecuentesForm';
import * as validations from '../../validations/validations';
import * as preguntasfrecuentesActions from '../../actions/preguntasfrecuentesActions';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import withRouter from '../common/withRouter';
import { Segment} from 'semantic-ui-react';
import {genericFormattedForDropdown} from '../../selectors/selectors';
import moment from 'moment';
import {getMargenes} from '../../util/';
import $ from 'jquery';


import {usuarioActual} from '../../util';
import * as userActions from '../../actions/userActions';
import * as menuActions from '../../actions/menuActions';

import * as paginaActions from '../../actions/paginaActions';



class ManagePreguntasFrecuentesForm extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
            errors:{},
            permisos:{},
			preguntasfrecuentes:{
                    }
		};
		
	}
    
    
    componentDidMount(){
        usuarioActual(this, "preguntasfrecuentes",true).then( (usuario)=>{
           let id=this.props.id;
        this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);  
            if(id && id>0 ){
            
               this.props.preguntasfrecuentesActions.getPreguntasFrecuentes(id, usuario).then( preguntasfrecuentes=>{
               this.setState({"preguntasfrecuentes":preguntasfrecuentes});
               })
                .catch(error=>{
                  toastr.error(error);
                }); 
            }
       })
        .catch(error=>{
          toastr.error(error);
        }); 
        
   
        
		
    }
    

    handleChange=(event, data)=> {

        let preguntasfrecuentes = this.state.preguntasfrecuentes;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		preguntasfrecuentes[field[0]]= value;
		else{
             if(!preguntasfrecuentes[field[0]]){
                    preguntasfrecuentes[field[0]]={}
                }
			preguntasfrecuentes[field[0]][field[1]]= value;
		}
        
		
        this.setState({"preguntasfrecuentes": preguntasfrecuentes});
    }
    
    
    FormIsValid(){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        let preguntasfrecuentes=this.state.preguntasfrecuentes;
              
        if(!validations.requerido(preguntasfrecuentes.pregunta)){
            errors.pregunta=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(preguntasfrecuentes.respuesta)){
            errors.respuesta=true;
            formIsValid=false;
        }
        
        this.setState({
            "errors":errors
        });
        
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }



    onSave=(event)=>{
        event.preventDefault();
        if(!this.FormIsValid()){
            return ;
        }
       
        
        this.props.preguntasfrecuentesActions.save(this.state.preguntasfrecuentes, this.props.user).then(() => {
            toastr.success("Registro guardado!!!.");
            //this.props.history.push('/preguntasfrecuentess');
            this.props.navigate(-1);
        });
        
    }

       
    render() {	
          
   let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		 		return (
              <Segment  style={margenes}>
                <PreguntasFrecuentesForm 
                    strings={this.props.strings}
                    id={this.props.id}
                    onChange={this.handleChange}
                    errors={this.state.errors}
                    datos={this.state.preguntasfrecuentes}
                    onSave={this.onSave}      
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    color={this.props.color}
                    form={this.props.form}
                    permisos={this.state.permisos}
                    
                />

            </Segment> 
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
    return {        
        ajaxCallInProgress:state.ajaxCallInProgress,
        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda, 
         color:state.color,
        user:state.user, 
        idioma:state.idioma,
        form:state.form,
        strings:state.strings
    }

}

function mapDispatchToProps(dispatch){

	return {   
        menuActions: bindActionCreators(menuActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch),
 showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
         paginaActions: bindActionCreators(paginaActions, dispatch),
                 preguntasfrecuentesActions: bindActionCreators(preguntasfrecuentesActions, dispatch)
	};
}


export default connect (mapStateToProps, mapDispatchToProps)(withRouter(ManagePreguntasFrecuentesForm));